<template>
  <div
    class="z-50 flex size-full items-center justify-center"
    @click="open">
    <div
      v-if="selected.length > 0"
      class="group flex h-full cursor-pointer flex-col items-center justify-center">
      <svg
        class="m-3 size-4 text-primary"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 5H5C3.93913 5 2.92172 5.42143 2.17157 6.17157C1.42143 6.92172 1 7.93913 1 9V29M1 29V33C1 34.0609
          1.42143 35.0783 2.17157 35.8284C2.92172 36.5786 3.93913 37 5 37H29C30.0609 37 31.0783 36.5786 31.8284
          35.8284C32.5786 35.0783 33 34.0609 33 33V25M1 29L10.172 19.828C10.9221 19.0781 11.9393 18.6569 13
          18.6569C14.0607 18.6569 15.0779 19.0781 15.828 19.828L21 25M33 17V25M33 25L29.828 21.828C29.0779
          21.0781 28.0607 20.6569 27 20.6569C25.9393 20.6569 24.9221 21.0781 24.172 21.828L21 25M21 25L25 29M29 5H37M33 1V9M21 13H21.02"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="text-sm font-semibold text-font">Update media</span>
    </div>
    <div
      v-else
      class="group flex h-full cursor-pointer flex-col items-center justify-center">
      <svg
        class="m-3 size-8 text-primary"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 5H5C3.93913 5 2.92172 5.42143 2.17157 6.17157C1.42143 6.92172 1 7.93913 1 9V29M1 29V33C1 34.0609
          1.42143 35.0783 2.17157 35.8284C2.92172 36.5786 3.93913 37 5 37H29C30.0609 37 31.0783 36.5786 31.8284
          35.8284C32.5786 35.0783 33 34.0609 33 33V25M1 29L10.172 19.828C10.9221 19.0781 11.9393 18.6569 13 18.6569C14.0607
          18.6569 15.0779 19.0781 15.828 19.828L21 25M33 17V25M33 25L29.828 21.828C29.0779 21.0781 28.0607 20.6569 27
          20.6569C25.9393 20.6569 24.9221 21.0781 24.172 21.828L21 25M21 25L25 29M29 5H37M33 1V9M21 13H21.02"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="text-sm font-semibold text-font">Add media (max 20MB)</span>
      <span class="text-sm text-font-light">Get started by choosing media</span>
      <button
        type="button"
        class="mt-4 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-3 py-2
        text-sm font-medium leading-4 text-white shadow-sm
        focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 group-hover:bg-indigo-700">
        <svg
          class="-ml-0.5 mr-2 size-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        Choose media
      </button>
    </div>
  </div>

  <large-modal
    :show="show"
    title="Add media"
    subtitle="Get started by selecting media (max 100MB)"
    size="max-w-7xl w-[calc(100vw-4rem)]"
    :footer="false"
    @close="close">
    <div class="-m-5">
      <div>
        <div class="sm:hidden">
          <select
            id="tabs"
            class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
            <option
              v-for="(tabSettings, tabId) in tabs"
              :key="tabId"
              :selected="tabId">
              {{ tabSettings.name }}
            </option>
          </select>
        </div>
        <div class="hidden sm:block">
          <div class="border-b border-gray-200">
            <nav
              class="-mb-px flex space-x-8 px-4"
              aria-label="Tabs">
              <span
                v-for="(tabSettings, tabId) in tabs"
                :key="tabSettings.name"
                :class="[
                  tabId === currentTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'cursor-pointer border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium'
                ]"
                :aria-current="tabId === currentTab ? 'page' : undefined"
                @click="setTab(tabId)">{{ tabSettings.name }}</span>
            </nav>
          </div>
        </div>
      </div>
      <div
        class="flex h-full"
        style="min-height: 60vh;">
        <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
          <div class="relative z-0 flex flex-1 flex-col overflow-hidden lg:flex-row">
            <main class="relative z-0 flex-1 overflow-y-auto bg-gray-100 focus:outline-none">
              <!-- Start main area-->
              <div
                class="absolute inset-0 p-4"
                :class="{'overflow-hidden': downloading}">
                <div
                  v-if="form.processing && form.progress"
                  class="my-6 w-full rounded-full bg-gray-200 dark:bg-gray-700">
                  <div
                    class="rounded-full bg-blue-600 p-0.5 text-center text-xs font-medium leading-none text-blue-100"
                    :style="'width:' + form.progress.percentage + '%'">
                    {{ form.progress.percentage }}
                  </div>
                </div>
                <template v-else>
                  <div
                    v-if="currentTab === 'unsplash' || currentTab === 'all'"
                    class="relative mb-3 rounded-md shadow-sm">
                    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                      <svg
                        class="size-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true">
                        <path
                          fill-rule="evenodd"
                          d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                          clip-rule="evenodd" />
                      </svg>
                    </div>
                    <input
                      id="search"
                      v-model="searchInput"
                      type="search"
                      name="search"
                      class="block w-full rounded-md border-0 py-1.5 pl-10
                      ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary
                      sm:text-sm sm:leading-6"
                      :class="{'disabled:cursor-not-allowed disabled:opacity-50': !currentTabLoaded}"
                      :disabled="!currentTabLoaded"
                      :title="!currentTabLoaded ? 'Please wait for the current tab media to load' : ''"
                      :placeholder="!currentTabLoaded ? 'Loading media, please wait..' : 'Search'"
                      @input="debouncedSearchInput">
                  </div>
                  <div
                    v-if="!currentTabLoaded"
                    class="group flex size-full flex-col items-center justify-center">
                    <spinning-circle />
                  </div>

                  <ul
                    v-else-if="tabsMedia[currentTab]?.length > 0"
                    role="list"
                    class="grid grid-cols-2 gap-4 sm:grid-cols-3">
                    <li
                      v-for="file in tabsMedia[currentTab]"
                      :key="file.id"
                      class="relative"
                      @click="() => (currentTab === 'unsplash' && !file?.urls?.regular) ? null : selectOrDeselect(file)">
                      <media-picker-unsplash-item
                        v-if="currentTab === 'unsplash'"
                        :file="file"
                        :is-selected="isSelected(file)" />
                      <media-picker-item
                        v-else
                        :file="file"
                        :is-selected="isSelected(file)" />
                    </li>
                  </ul>
                  <div
                    v-else-if="currentTab === 'all' && tabsMedia[currentTab] === undefined"
                    class="group relative flex h-72 w-full flex-col items-center justify-center">
                    <span class="text-sm font-semibold text-font">No results displayed</span>
                    <span class="text-sm text-font-light">Results are not displayed before you search</span>
                  </div>

                  <nav
                    v-if="currentTabLoaded && (searchTotal > searchPerPage) && (currentTab === 'unsplash' || currentTab === 'all')"
                    class="flex items-center justify-between py-6 pt-3"
                    aria-label="Pagination">
                    <div class="hidden sm:block">
                      <p class="text-sm text-gray-700">
                        Showing
                        <span class="font-medium">{{ (searchPage-1) * searchPerPage + 1 }}</span>
                        to
                        <span class="font-medium">{{ (searchPage * searchPerPage) > searchTotal ? searchTotal : searchPage * searchPerPage }}</span>
                        of
                        <span class="font-medium">{{ searchTotal }}</span>
                        results
                      </p>
                    </div>
                    <div class="flex flex-1 justify-between sm:justify-end">
                      <button
                        v-if="searchPage > 1"
                        class="relative inline-flex items-center rounded-md bg-white px-3 py-2
                        text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
                        @click="previousPage">
                        Previous
                      </button>
                      <p
                        v-else
                        class="relative inline-flex cursor-not-allowed items-center rounded-md bg-white px-3 py-2
                        text-sm font-semibold text-gray-300 ring-1 ring-inset ring-gray-300 focus-visible:outline-offset-0">
                        Previous
                      </p>
                      <button
                        v-if="searchPages > searchPage"
                        class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2
                        text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
                        @click="nextPage">
                        Next
                      </button>
                      <p
                        v-else
                        class="relative ml-3 inline-flex cursor-not-allowed items-center rounded-md bg-white px-3 py-2
                        text-sm font-semibold text-gray-300 ring-1 ring-inset ring-gray-300 focus-visible:outline-offset-0">
                        Next
                      </p>
                    </div>
                  </nav>

                  <template v-else-if="typeof tabsMedia[currentTab] !== 'undefined' && tabsMedia[currentTab]?.length === 0">
                    <div
                      v-if="currentTab === 'unsplash' || currentTab === 'all'"
                      class="group flex size-full flex-col items-center justify-center">
                      <span class="text-sm font-semibold text-font">No results</span>
                      <span class="text-sm text-font-light">Change your search string</span>
                    </div>
                    <div
                      v-else
                      class="group flex size-full flex-col items-center justify-center"
                      @click="chooseMedia">
                      <svg
                        class="m-3 size-8 text-primary"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M21 5H5C3.93913 5 2.92172 5.42143 2.17157 6.17157C1.42143 6.92172 1 7.93913 1 9V29M1 29V33C1 34.0609 1.42143 35.0783 2.17157
                          35.8284C2.92172 36.5786 3.93913 37 5 37H29C30.0609 37 31.0783 36.5786 31.8284 35.8284C32.5786 35.0783 33 34.0609 33 33V25M1
                          29L10.172 19.828C10.9221 19.0781 11.9393 18.6569 13 18.6569C14.0607 18.6569 15.0779 19.0781 15.828 19.828L21 25M33 17V25M33
                          25L29.828 21.828C29.0779 21.0781 28.0607 20.6569 27 20.6569C25.9393 20.6569 24.9221 21.0781 24.172 21.828L21 25M21 25L25
                          29M29 5H37M33 1V9M21 13H21.02"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                      <span class="text-sm font-semibold text-font">Upload images</span>
                      <span class="text-sm text-font-light">There is nothing here :(</span>
                      <span class="text-sm text-font-light">Get started by uploading some images</span>
                      <button
                        v-if="tabs[currentTab]?.upload !== null"
                        type="button"
                        class="mt-4 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-3 py-2
                        text-sm font-medium leading-4 text-white shadow-sm
                        focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 group-hover:bg-indigo-700">
                        <svg
                          class="-ml-0.5 mr-2 size-4"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                        Upload images
                      </button>
                    </div>
                  </template>
                </template>
              </div>
              <div
                v-if="downloading"
                class="absolute inset-0 flex flex-col items-center justify-center space-y-3 bg-gray-800 bg-opacity-75 text-white">
                <spinning-circle />
                <p>Downloading image...</p>
              </div>
              <!-- End main area -->
            </main>
            <aside class="flex w-full flex-col justify-between border-l border-gray-200 lg:w-96">
              <!-- Start secondary column (hidden on smaller screens) -->
              <div class="hidden p-4 lg:block">
                <ul
                  role="list"
                  class="grid grid-cols-2 gap-4">
                  <li
                    v-for="file in selectedMedia"
                    :key="file.id"
                    class="relative"
                    @click="selectOrDeselect(file)">
                    <div class="group aspect-h-7 aspect-w-10 relative block w-full overflow-hidden rounded-lg bg-gray-100">
                      <img
                        :src="file.original_url"
                        alt=""
                        class="pointer-events-none object-cover group-hover:opacity-75">
                      <button
                        type="button"
                        class="absolute inset-0 focus:outline-none">
                        <span class="sr-only">View details for {{ file.name }}</span>
                      </button>
                      <div class="absolute inset-0">
                        <svg
                          class="absolute right-1 top-1 size-3.5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="2.5"
                          stroke="currentColor">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </div>
                    </div>

                    <p class="pointer-events-none mt-1 block truncate text-xs font-medium text-font">
                      {{ file.name }}
                    </p>
                  </li>
                </ul>
              </div>
              <div class="flex items-center justify-between border-t border-gray-200 p-4 lg:justify-end">
                <div class="flex size-8 items-center justify-center rounded-md border-2 border-primary text-lg font-bold lg:hidden">
                  <span class="text-primary">{{ selectedMedia.length }}</span>
                </div>
                <div class="flex space-x-4">
                  <button
                    v-if="tabs[currentTab]?.upload !== null"
                    type="button"
                    class="inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700
                    shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    @click="chooseMedia">
                    <svg
                      class="-ml-0.5 mr-2 size-4"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Upload media
                  </button>
                  <button
                    type="button"
                    class="inline-flex items-center rounded border border-transparent bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white
                    shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    :class="{'cursor-not-allowed opacity-50': selectedMedia.length === 0}"
                    @click="addMedia">
                    Save
                  </button>
                  <input
                    :id="uid + '_mediaUpload'"
                    name="media[]"
                    type="file"
                    class="hidden"
                    multiple
                    @input="form.media = $event.target.files">
                </div>
              </div>
              <!-- End secondary column -->
            </aside>
          </div>
        </div>
      </div>
    </div>
  </large-modal>
  <alert-modal
    :show="sizeTooBig"
    @close="sizeTooBig = false">
    <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
      !
    </div>
    <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Selected file too large
      </h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          Max filesize is 50MB. Please select another file for upload.
        </p>
      </div>
    </div>
    <template #buttons>
      <button
        type="button"
        class="inline-flex items-center rounded border border-transparent bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white
        shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        @click="sizeTooBig = false">
        OK
      </button>
    </template>
  </alert-modal>
  <alert-modal
    :show="totalTooBig"
    @close="totalTooBig = false">
    <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
      !
    </div>
    <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Selected files too large
      </h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          Max total filesize is 100MB. Please select fewer files for upload.
        </p>
      </div>
    </div>
    <template #buttons>
      <button
        type="button"
        class="inline-flex items-center rounded border border-transparent bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white
        shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        @click="totalTooBig = false">
        OK
      </button>
    </template>
  </alert-modal>
</template>

<script setup>
import {
  computed,
  onMounted, onUnmounted, onUpdated, ref, watch,
} from 'vue';
import {
  useForm, usePage,
} from '@inertiajs/vue3';
import { notify } from 'notiwind';
import LargeModal from '@/ComponentsDeprecated/Modal/LargeModal.vue';
import AlertModal from '@/ComponentsDeprecated/Modal/AlertModal.vue';
import MediaPickerItem from '@/Components/Media/MediaPickerItem.vue';
import MediaPickerUnsplashItem from '@/Components/Media/MediaPickerUnsplashItem.vue';
import SpinningCircle from '@/ComponentsDeprecated/Loaders/SpinningCircle.vue';
import { useSystemStore } from '@/Stores/System';
import {debounce} from "lodash";

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */

const props = defineProps({
  settings: {
    type: Object,
    required: true,
  },
  selected: {
    type: Array,
    required: true,
  },
  default_search: {
    type: String,
    required: false,
    default: '',
  },
  includeDefaultTabs: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits(['update']);

const defaultSearch = computed(() => props.default_search);

const show = ref(false);
const form = useForm({ media: [] });

const uid = Math.random().toString(36).substr(2, 10);
const settings = computed(() => props.settings);
const currentTab = ref(Object.keys(settings.value)[0]);
const currentTabLoaded = ref(false);

const sizeTooBig = ref(false);
const totalTooBig = ref(false);
const maxMediaSize = 50 * 1024 * 1024;
const maxPostSize = 100 * 1024 * 1024;

const selectedMedia = ref([]);
const downloading = ref(false);

const searchInput = ref('');
const searchString = ref('');

const searchPage = ref(1);
const searchPages = ref(0);
const searchTotal = ref(0);
const searchPerPage = ref(30);

let cancelTokenSource = null;

const tabs = computed(() => {
  const teamId = usePage().props.team?.id;

  const standardTabs = props.includeDefaultTabs && teamId ? {
    unsplash: {
      name: 'Unsplash',
      get: null,
      upload: null,
    },
    all: {
      name: 'All Team Media',
      get: route('api.team.media.search', { team: teamId }),
      upload: null,
    },
  } : {};

  return {
    ...settings.value, ...standardTabs,
  };
});

const tabsMedia = ref({
  unsplash: null,
  all: null,
});

/* *********************************************************************
 * Component functions
 * ****************************************************************** */

/**
 * Fetch media from API
 */
async function fetchMedia() {
  if (cancelTokenSource) {
    cancelTokenSource.cancel('Request canceled due to new fetch.');
  }
  cancelTokenSource = axios.CancelToken.source();

  if (!show.value) {
    return;
  }

  const apiUrl = currentTab.value === 'unsplash'
    ? `${route('api.unsplash.search')}?search=${searchString.value}&per_page=${searchPerPage.value}`
    : tabs.value[currentTab.value]?.get;

  currentTabLoaded.value = false;

  try {
    const response = await axios.get(apiUrl, {
      cancelToken: cancelTokenSource.token,
      params: {
        page: searchPage.value,
        per_page: searchPerPage.value,
        search: searchString.value,
      },
    });

    const media = (currentTab.value === 'unsplash' || currentTab.value === 'all')
      ? response.data.results
      : response.data;

    if (currentTab.value === 'unsplash' || currentTab.value === 'all') {
      searchPages.value = response.data.pages;
      searchTotal.value = response.data.total;
      searchPerPage.value = response.data.per_page;
    }

    tabsMedia.value[currentTab.value] = media;
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error('Error fetching media:', error);
    }
  } finally {
    currentTabLoaded.value = true;
  }
}

/**
 * Debounce the search input
 */
const debouncedSearchInput = debounce(() => {
  searchString.value = searchInput.value;
  searchPage.value = 1;
  fetchMedia();
}, 1200);

/**
 * Choose media from computer
 */
function chooseMedia() {
  document.getElementById(`${uid}_mediaUpload`).click();
}

/**
 * Upload media to API
 */
function uploadMedia() {
  currentTabLoaded.value = false;
  const inputSize = document.getElementById(`${uid}_mediaUpload`);
  const filesList = inputSize.files;
  const file = filesList[0];
  const totalFiles = [];
  for (let i = 0; i < filesList.length; i++) {
    const fileSize = filesList[i].size;
    totalFiles.push(fileSize);
  }
  const total = totalFiles.reduce((a, b) => a + b, 0);

  if (filesList.length > 0) {
    if (file.size > maxMediaSize) {
      sizeTooBig.value = true;
      inputSize.value = null;
      form.reset();
    } else if (total > maxPostSize) {
      totalTooBig.value = true;
      inputSize.value = null;
      form.reset();
    } else {
      form.post(tabs.value[currentTab.value].upload, {
        errorBag: 'uploadMedia',
        onSuccess: () => {
          notify({
            type: 'success',
            title: 'Media uploaded',
            text: `Uploaded to ${tabs.value[currentTab.value].name}`,
          }, 4000);
        },
        onError: (err) => {
          notify({
            type: 'danger',
            title: 'Something went wrong',
            text: 'Could not upload images',
          }, 4000);
          console.log(err);
        },
        onFinish: () => {
          inputSize.value = null;
          form.reset();
          fetchMedia();
        },
      });
    }
  }
}

/**
 * Reset all media
 */
function resetAll() {
  currentTabLoaded.value = false;
  Object.keys(tabs.value).forEach((tab) => {
    if (typeof tabsMedia.value[tab] !== 'undefined') {
      delete tabsMedia.value[tab];
    }
  });
}

/**
 * Reset all media except the current tab
 */
function resetOther() {
  Object.keys(tabs.value).forEach((tab) => {
    if (tab !== currentTab.value && typeof tabsMedia.value[tab] !== 'undefined') {
      delete tabsMedia.value[tab];
    }
  });
}

/**
 * Open modal
 */
function open() {
  selectedMedia.value = JSON.parse(JSON.stringify(props.selected));
  show.value = true;
  if (!tabsMedia.value[currentTab.value]) {
    setTimeout(() => {
      fetchMedia();
    }, 100);
  }
}

/**
 * Close modal
 */
function close() {
  show.value = false;
}

/**
 * Add media to parent component
 */
function addMedia() {
  emit('update', selectedMedia.value);
  close();
}

/**
 * Set current tab
 * @param {string} id - Tab id
 */
function setTab(id) {
  currentTab.value = id;
  if (!tabsMedia.value[currentTab.value]) {
    currentTabLoaded.value = false;
  }
  searchPage.value = 1;
  fetchMedia();
}

/**
 * Check if object is selected
 * @param {object} obj - Object to check
 * @returns {boolean} - True if object is selected
 */
function isSelected(obj) {
  const object = selectedMedia.value.filter((o) => o.id === obj.id || o.custom_properties?.unsplash_id === obj.id);

  return object.length > 0;
}

/**
 * Select or deselect object
 * @param {object} obj - Object to select or deselect
 */
function selectOrDeselect(obj) {
  const object = selectedMedia.value.filter((o) => o.id === obj.id || o.custom_properties?.unsplash_id === obj.id);
  if (object.length === 0) {
    if (typeof obj.id === 'string') {
      resetOther();
      downloading.value = true;
      axios.post(route('api.unsplash.store'), obj).then((response) => {
        selectedMedia.value.push(response.data);
        emit('crop', null);
      }).finally(() => {
        downloading.value = false;
      });
    } else {
      selectedMedia.value.push(obj);
    }
  } else {
    selectedMedia.value.splice(selectedMedia.value.indexOf(object[0]), 1);
  }
}

/**
 *  Go to next page
 */
function nextPage() {
  searchPage.value++;
  fetchMedia();
}

/**
 * Go to previous page
 */
function previousPage() {
  searchPage.value--;
  fetchMedia();
}

/* *********************************************************************
 * Page lifecycle functions
 * ****************************************************************** */

watch(() => form.media, () => {
  uploadMedia();
});

watch(tabs, () => {
  fetchMedia();
});

onMounted(() => {
  searchInput.value = defaultSearch.value ?? '';
  searchString.value = defaultSearch.value ?? '';
  resetAll();
});

onUnmounted(() => {
  debouncedSearchInput.cancel();
  if (cancelTokenSource) {
    cancelTokenSource.cancel('Component unmounted.');
  }
});

</script>

<script>
// fix from converting this component from options to composition API
export default {
  inheritAttrs: false,
};
</script>
